import { IconCheck, IconCopy } from "@tabler/icons-react";
import type { FC } from "react";
import { useCopyAction } from "../clipboard/useCopyAction.js";

export interface MetaFieldRowProps {
  label: string;
  value: string;
}

export const MetaFieldRow: FC<MetaFieldRowProps> = (props) => {
  const { didJustCopy, onCopy } = useCopyAction(props.value);

  return (
    <div
      onClick={onCopy}
      className="group/row -mx-2 flex cursor-pointer items-center justify-between rounded-md px-2 py-1.5 transition-colors hover:bg-slate-50"
    >
      <div className="flex min-w-0 flex-1 items-baseline gap-2">
        <span className="w-20 shrink-0 text-[11px] text-slate-400">
          {props.label}
        </span>
        <span className="min-w-0 truncate text-xs font-medium text-foreground">
          {props.value}
        </span>
      </div>
      <span className="shrink-0 opacity-0 transition-opacity group-hover/row:opacity-100">
        {didJustCopy ? (
          <IconCheck className="size-3.5 text-emerald-500" />
        ) : (
          <IconCopy className="size-3.5 text-slate-400 hover:text-muted-foreground" />
        )}
      </span>
    </div>
  );
};
